import {
    CHANGE_PULS_CUSTOMER_REQUEST,
    CHANGE_PULS_CUSTOMER_RESULT,
    CHANGE_PULS_CUSTOMER_OPEN_MODAL,
    CHANGE_PULS_CUSTOMER_CLOSE_MODAL,
    CHANGE_PULS_CUSTOMER_GET_DEVICE_REQUEST,
    CHANGE_PULS_CUSTOMER_GET_DEVICE_RESULT,
    CHANGE_PULS_CUSTOMER_SET_DEVICE,
    CHANGE_PULS_CUSTOMER_SEARCH_ACCOUNTS_CTC_REQUEST,
    CHANGE_PULS_CUSTOMER_SEARCH_ACCOUNTS_CTC_RESULT,
    CHANGE_PULS_UPDATE_ACCOUNT_REQUEST,
} from 'Redux/actionTypes';

export const changePulsCustomerUpdateAccountRequest = (data) => ({
    type: CHANGE_PULS_UPDATE_ACCOUNT_REQUEST,
    payload: data
})

export const changePulsCustomerSearchAccountsRequest = () => ({
    type: CHANGE_PULS_CUSTOMER_SEARCH_ACCOUNTS_CTC_REQUEST
})

export const changePulsCustomerSearchAccountsResult = (data) => ({
    type: CHANGE_PULS_CUSTOMER_SEARCH_ACCOUNTS_CTC_RESULT,
    payload: data
})

export const changePulsCustomerRequest = (data) => ({
    type: CHANGE_PULS_CUSTOMER_REQUEST,
    payload: data
})

export const changePulsCustomerResult = (result, response) => ({
    type: CHANGE_PULS_CUSTOMER_RESULT,
    payload: { result, response }
})

export const changePulsCustomerOpenModal = (items, calampApi) => ({
    type: CHANGE_PULS_CUSTOMER_OPEN_MODAL,
    payload: { items, calampApi }
})

export const changePulsCustomerCloseModal = () => ({
    type: CHANGE_PULS_CUSTOMER_CLOSE_MODAL
})

export const changePulsCustomerGetDeviceRequest = (item) => ({
    type: CHANGE_PULS_CUSTOMER_GET_DEVICE_REQUEST,
    payload: item
})

export const changePulsCustomerGetDeviceResult = (result) => ({
    type: CHANGE_PULS_CUSTOMER_GET_DEVICE_RESULT,
    payload: result
})

export const changePulsCustomerSetDevice = (device) => ({
    type: CHANGE_PULS_CUSTOMER_SET_DEVICE,
    payload: device
})